import React, { useEffect, useState } from "react";
import { useGetCustomJournalDetail } from "../../Controllers/Journal/JournalController";

const JournalDetailSection = ({ journal, onCreationDate }) => {
  const [journalData, setJournalData] = useState(null);
  const getCustomJournalDetail = useGetCustomJournalDetail();

  const categoryOrder = ["title", "lesson", "summary", "full"];
  const sortedTypes = journalData?.requested_types
    ? [...journalData.requested_types].sort(
        (a, b) => categoryOrder.indexOf(a) - categoryOrder.indexOf(b),
      )
    : [];

  useEffect(() => {
    if (journal?.user_journal_id && journal?.journal_keywords) {
      const payload = {
        user_journal_id: journal.user_journal_id,
        journal_keywords: journal.journal_keywords,
      };
      setJournalData(null);
      getCustomJournalDetail.mutate(payload, {
        onSuccess: (response) => {
          const data = response.custom_journal;
          setJournalData(data);
          if (onCreationDate && data?.created_at) {
            const dateStr = new Date(data.created_at).toLocaleDateString(
              "en-US",
              {
                month: "long",
                day: "numeric",
                year: "numeric",
              },
            );
            onCreationDate(dateStr);
          }
        },
        onError: (error) => {
          console.error("Error fetching journal details:", error);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [journal?.user_journal_id, JSON.stringify(journal?.journal_keywords)]);

  return (
    <div
      className="journal-details-section"
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        borderRadius: "24px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          backgroundColor: "#121E29",
          padding: "24px",
          scrollbarWidth: "thin",
        }}
      >
        {getCustomJournalDetail.isPending && (
          <div style={{ color: "#e6ecf1", textAlign: "center" }}>
            Loading...
          </div>
        )}
        {getCustomJournalDetail.isError && (
          <div style={{ color: "#ff6b6b", textAlign: "center" }}>
            Failed to load details.
          </div>
        )}

        {journalData &&
          sortedTypes.map((type) => (
            <div
              key={type}
              className="journal-category"
              style={{ marginBottom: "24px" }}
            >
              <h4
                style={{
                  color: "#e6ecf1",
                  textTransform: "capitalize",
                  marginBottom: "16px",
                  paddingBottom: "8px",
                  borderBottom: "1px solid #333",
                  fontWeight: 600,
                }}
              >
                {type}
              </h4>
              {journalData.data[type]?.map((item, index) => (
                <React.Fragment key={`${type}-${index}`}>
                  <div
                    className="message-bubble"
                    style={{
                      backgroundColor: "#1B2C3A",
                      borderRadius: "8px",
                      padding: "16px 24px",
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "1.5",
                    }}
                  >
                    {item.question}
                  </div>
                  <div
                    className="message-bubble"
                    style={{
                      padding: "10px",
                      marginBottom: "16px",
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "1.5",
                    }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </div>
                </React.Fragment>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default JournalDetailSection;
